import { Fragment } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { BiErrorCircle } from "react-icons/bi";
import { Grid, Typography as MuiTypography } from "@mui/material";

import { PrimaryButton } from "../css components/Button";

const Icon = styled(BiErrorCircle)`
  width: 100px;
  height: 100px;
  color: red;
`;

const Typography = styled(MuiTypography)`
  text-align: center;
`;

export default function TimeOut({ disableHomeButton }) {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Grid container spacing={2} justifyContent="center">
        <Grid item>
          <Icon />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h5">
            Something went wrong while loading the data.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h5" gutterBottom>
            TIMEOUT
          </Typography>
        </Grid>

        {!disableHomeButton && (
          <Grid item>
            <PrimaryButton variant="contained" onClick={() => navigate("/")}>
              Home
            </PrimaryButton>
          </Grid>
        )}

        <Grid item>
          <PrimaryButton
            variant="contained"
            onClick={() => window.location.reload()}
          >
            Retry
          </PrimaryButton>
        </Grid>
      </Grid>
    </Fragment>
  );
}
